// extracted by mini-css-extract-plugin
export default {"form":"Filtration_form__Gp0Cy","search":"Filtration_search__bojtZ","filtration":"Filtration_filtration__2qCUe"};